import React from 'react';
import { motion } from 'framer-motion';
export function Quote() {
  return <section className="py-16 md:py-32 bg-leaf-dark relative overflow-hidden" data-id="element-123">
      {/* Julienne texture */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-124">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-125">
          <defs data-id="element-126">
            <pattern id="julienne-quote" x="0" y="0" width="70" height="50" patternUnits="userSpaceOnUse" patternTransform="rotate(-10)" data-id="element-127">
              <path d="M0 25 Q17 18, 35 25 T70 25" fill="none" stroke="#fff" strokeWidth="1.5" opacity="0.5" data-id="element-128" />
              <path d="M0 10 Q17 3, 35 10 T70 10" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" data-id="element-129" />
              <path d="M0 40 Q17 33, 35 40 T70 40" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" data-id="element-130" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#julienne-quote)" data-id="element-131" />
        </svg>
      </div>

      {/* Decorative blobs */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-72 h-72 bg-leaf rounded-full blur-3xl opacity-20" data-id="element-132"></div>
      <div className="absolute top-0 right-0 w-56 h-56 bg-cabbage rounded-full blur-3xl opacity-10" data-id="element-133"></div>

      <div className="container mx-auto px-5 md:px-6 max-w-4xl text-center relative z-10" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-135">
          <span className="absolute -top-10 md:-top-16 left-1/2 -translate-x-1/2 text-7xl md:text-9xl text-white/15 font-serif leading-none" data-id="element-136">
            "
          </span>
          <blockquote className="text-2xl md:text-5xl font-serif text-white leading-snug md:leading-tight italic relative z-10" data-id="element-137">
            Ideal para quienes buscan comer mejor, innovar en la cocina y
            descubrir nuevas formas de disfrutar el repollo en cualquier momento
            del día.
          </blockquote>
          <div className="mt-8 flex items-center justify-center gap-3" data-id="element-138">
            <div className="w-12 h-[2px] bg-gold-light" data-id="element-139"></div>
            <span className="text-gold-light font-sans text-sm tracking-widest uppercase" data-id="element-140">
              Para ti
            </span>
            <div className="w-12 h-[2px] bg-gold-light" data-id="element-141"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}